module.exports = __webpack_public_path__ + "static/fbc-077744d5db9d281abc4e6aa36cddcf00.png";